export default __webpack_public_path__ + "static/media/screenshot-03.a28f0597.jpg";